import convertBase64ToBlob from "./convertBase64ToBlob";

/**
 * Download file from base64 string
 *
 * @param {string} fileData - The base64 string of the file
 * @param {string} filename - The name of the file to be downloaded
 * @param {string} contentType - The content type of the file
 *
 * @returns {void}
 */
export default function downloadFileFromBase64(fileData, filename, contentType) {
  const blob = convertBase64ToBlob(fileData, contentType);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
